
export function GoogleCustomSearchResults() {
    return (
            <div className="gcse-searchresults-only" data-gname="gcs"></div>
    );
}
